import SurveyPage from 'containers/SurveyPage/Loadable';
import SurveysPage from 'containers/SurveysPage/Loadable';
import AccountLayoutPage from 'containers/AccountLayoutPage/Loadable';
// eslint-disable-next-line
import ThirdPartyResultsPage from 'containers/ThirdPartyResultsPage/Loadable';

// import routed components here
export const SurveyRoutes = [
  {
    path: '/survey/third-party/:surveyId/analytics',
    component: ThirdPartyResultsPage,
  },
  {
    path: '/survey/:page/:surveyId/:subpage?',
    component: SurveyPage,
  },
  {
    path: '/surveys/:folderId?',
    component: SurveysPage,
  },
];

export const AccountRoutes = [
  { path: '/account/:subpage?', component: AccountLayoutPage },
];
